<div class="our-products" [class.our-products--mobile]="isMobile()">
  <div class="our-products__inner">

  <!-- Documentation & Helps card -->
  <div class="info-card">

    <div class="info-card__section">
      <h2 class="info-card__title">Documentation</h2>
      <p class="info-card__desc">
        Access all the resources you need to install, configure, and efficiently use and/or our solutions.
        Find detailed guides, practical tutorials, and technical documentation to support your teams every step of the way.
      </p>
      <app-button
        variant="secondary"
        color="amarante"
        size="small"
        label="Open documentation"
        [addIconRight]="true"
        [fullWidth]="isMobile()"
        (clicked)="openDocumentation()"
        data-attr="our-products-btn-open-documentation">
        <span slot="icon-right"
              style="display: inline-block; width: 10px; height: 16px;
                     background-color: #000;
                     -webkit-mask: url('assets/icon/new_icon/arrow-right.svg') no-repeat center / contain;
                     mask: url('assets/icon/new_icon/arrow-right.svg') no-repeat center / contain;"></span>
      </app-button>
    </div>

    <div class="info-card__divider"></div>

    <div class="info-card__section">
      <h2 class="info-card__title">Helps</h2>
      <p class="info-card__desc">
        Need help or additional information? Our team is available to answer your technical questions,
        support your projects, and help you get the most out of our products.
      </p>
      <div class="info-card__helps-row">
        <a class="info-card__email"
          [href]="'mailto:' + supportEmail()"
          data-attr="our-products-link-email">{{ supportEmail() }}</a>
        <app-button
          variant="secondary"
          color="amarante"
          size="small"
          label="Send mail"
          [fullWidth]="isMobile()"
          (clicked)="sendSupportMail()" />
      </div>
    </div>

  </div>

  <!-- Products separator -->
  <div class="products-separator">
    <hr class="products-separator__line" />
    <h2 class="products-separator__title">Products</h2>
    <hr class="products-separator__line" />
  </div>

  @if (loading()) {
    <div class="our-products__status" role="status" aria-live="polite">
      <p class="our-products__status-text">{{ "GLOBAL.CHARGEMENT" | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="our-products__status our-products__status--error" role="alert">
      <p class="our-products__status-text">{{ error() }}</p>
    </div>
  } @else {
  <div class="our-products__grid">
    @for (product of products(); track product.id) {
      <div class="product-card">

        <!-- Logo -->
        <div class="product-card__logo-wrap">
          @if (product.application === 'Explore') {
            <span
              class="product-card__logo"
              role="img"
              aria-label="Explore logo"
              style="display: block; height: 30px; aspect-ratio: 153 / 33;
                     background-color: var(--c-mint);
                     -webkit-mask: url('assets/icon/new_icon/logo-explore.svg') no-repeat center / contain;
                     mask: url('assets/icon/new_icon/logo-explore.svg') no-repeat center / contain;"></span>
          } @else if (product.application === 'Expertab') {
            <img class="product-card__logo" src="assets/icon/new_icon/logo-expertab.svg" alt="Expertab logo" />
          } @else if (product.application === 'Expertir') {
            <img class="product-card__logo" src="assets/icon/new_icon/logo-expertir.svg" alt="Expertir logo" />
          } @else if (product.application === 'Blendore') {
            <img class="product-card__logo" src="assets/icon/new_icon/logo-blendore.svg" alt="Blendore logo" />
          } @else {
            <img class="product-card__logo" src="#" [alt]="product.application + ' logo'" />
            <span class="product-card__logo-fallback">{{ product.application }}</span>
          }
        </div>

        <!-- Tagline -->
        <p class="product-card__tagline">{{ product.tagline }}</p>

        <!-- Divider -->
        <hr class="product-card__divider" />

        <!-- Screenshot -->
        @if (product.application === 'Explore') {
          <img class="product-card__image" src="assets/icon/new_icon/capture_explore.svg" alt="Explore screenshot" />
        } @else if (product.application === 'Expertab') {
          <img class="product-card__image" src="assets/icon/new_icon/capture_expertab.svg" alt="Expertab screenshot" />
        } @else if (product.application === 'Expertir') {
          <img class="product-card__image" src="assets/icon/new_icon/capture_expertir.svg" alt="Expertir screenshot" />
        } @else if (product.application === 'Blendore') {
          <img class="product-card__image" src="assets/icon/new_icon/capture_blendore.png" alt="Blendore screenshot" />
        } @else {
          <img class="product-card__image" src="#" [alt]="product.application + ' screenshot'" />
        }

        <!-- Features 2 columns -->
        <div class="product-card__features">
          <div class="product-card__features-col">
            @for (f of getLeftFeatures(product.features); track f) {
              <div class="product-card__feature-item">
                <span class="product-card__feature-dot"></span>
                <span class="product-card__feature-label">{{ f }}</span>
              </div>
            }
          </div>
          <div class="product-card__features-col">
            @for (f of getRightFeatures(product.features); track f) {
              <div class="product-card__feature-item">
                <span class="product-card__feature-dot"></span>
                <span class="product-card__feature-label">{{ f }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Divider -->
        <hr class="product-card__divider" />

        <!-- Action buttons: documentation + installer / open -->
        <div class="product-card__actions">
          <app-button
            variant="secondary"
            color="amarante"
            size="medium"
            label="Open documentation"
            [addIconRight]="true"
            [fullWidth]="true"
            [state]="hasDocumentation(product) ? 'default' : 'disabled'"
            [attr.data-attr]="'our-products-btn-open-doc' + product.id"
            (clicked)="openProductDocumentation(product)">
            <img slot="icon-right" width="10" height="16" src="assets/icon/new_icon/arrow-right.svg" alt="" />
          </app-button>

          @if (product.application === 'Explore') {
            <app-button
              variant="primary"
              color="amarante"
              size="medium"
              label="Open"
              [addIconRight]="true"
              [fullWidth]="true"
              routerLink="/"
              [attr.data-attr]="'our-products-btn-open-' + product.id">
              <img slot="icon-right" width="10" height="16" src="assets/icon/new_icon/arrow-right.svg" alt="" />
            </app-button>
          } @else {
            <app-button
              variant="primary"
              color="amarante"
              size="medium"
              label="Download installer"
              [addIconLeft]="true"
              [fullWidth]="true"
              [state]="hasInstaller(product) ? 'default' : 'disabled'"
              (clicked)="downloadProduct(product)"
              [attr.data-attr]="'our-products-btn-download-' + product.id">
              <svg slot="icon-left" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 11L3.5 6.5L4.55 5.45L7.25 8.15V1H8.75V8.15L11.45 5.45L12.5 6.5L8 11ZM2.5 15C2.1 15 1.75 14.85 1.45 14.55C1.15 14.25 1 13.9 1 13.5V11H2.5V13.5H13.5V11H15V13.5C15 13.9 14.85 14.25 14.55 14.55C14.25 14.85 13.9 15 13.5 15H2.5Z" fill="currentColor"/>
              </svg>
            </app-button>
          }
        </div>

        <!-- Version list: each row opens or downloads its changelog -->
        <div class="product-card__versions">
          @for (v of product.versions; track $index) {
            <div class="product-card__version-row">
              <div class="product-card__version-info">
                <span class="product-card__version-number">{{ v.version }}</span>
                <span class="product-card__version-date">{{ v.date }}</span>
              </div>
              <div class="product-card__version-actions">
                <app-button
                  variant="tertiary"
                  color="amarante"
                  size="xsmall"
                  label="Details"
                  [addIconLeft]="true"
                  [state]="v.changelog ? 'default' : 'disabled'"
                  [attr.data-attr]="'our-products-btn-dtails-' + product.id"
                  (clicked)="openChangelog(product, v)">
                  <svg slot="icon-left" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 3C4.5 3 1.7 5.1 1 8c0.7 2.9 3.5 5 7 5s6.3-2.1 7-5c-0.7-2.9-3.5-5-7-5Z" stroke="currentColor" stroke-width="1.3" fill="none"/>
                    <circle cx="8" cy="8" r="2" stroke="currentColor" stroke-width="1.3" fill="none"/>
                  </svg>
                </app-button>
                <app-button
                  variant="tertiary"
                  color="amarante"
                  size="xsmall"
                  [addLabel]="false"
                  [addIconLeft]="true"
                  [state]="canDownloadVersion(v) ? 'default' : 'disabled'"
                  [attr.title]="v.installerUrl ? 'Download installer' : 'Download changelog'"
                  [attr.aria-label]="v.installerUrl ? 'Download installer' : 'Download changelog'"
                  [attr.data-attr]="'our-products-btn-download-' + product.id"
                  (clicked)="downloadVersion(product, v)">
                  <span slot="icon-left"
                        style="display: inline-block; width: 16px; height: 16px;
                               background-color: currentColor;
                               -webkit-mask: url('assets/icon/new_icon/Importer.svg') no-repeat center / contain;
                               mask: url('assets/icon/new_icon/Importer.svg') no-repeat center / contain;"></span>
                </app-button>
              </div>
            </div>
          }
        </div>

      </div>
    }
  </div>
  }
  </div>
</div>

<!-- Changelog popup -->
<app-popup
  title="Changelog"
  [isOpen]="changelogPopupOpen()"
  size="medium"
  variant="secondary"
  color="mint"
  (closed)="closeChangelog()">

  @if (selectedChangelog(); as cl) {
    <div class="changelog-popup">
      <div class="changelog-popup__header">
        <span class="changelog-popup__version">{{ cl.version }}</span>
        <hr class="changelog-popup__divider" />
      </div>
      <span class="changelog-popup__date">{{ cl.date }}</span>
      <div class="changelog-popup__text" [innerHTML]="selectedChangelogHtml()"></div>
    </div>
  }

  <ng-container slot="footer">
    <app-button
      variant="secondary"
      color="amarante"
      size="medium"
      label="Close"
      (clicked)="closeChangelog()" />
  </ng-container>
</app-popup>
